import * as React from 'react';
import { ButtonInline } from 'ui';
import { BowtieSearchResult } from 'app/area/bowtie/bowtie-search-result';
import * as navigate from 'app/area/shared/navigation';
import { useSelectorsTile } from 'app/area/case-report/case-listing/hooks';
import { CaseResult } from 'app/area/case-report/case-listing/types-store';
import styles from './bowtie-listing-result-list-item.scss';

interface BowtieListingResultListItemProps {
  resultItem: CaseResult;
  translation?: any;
  height?: number;
}

export const BowtieListingResultListItem = ({
  resultItem,
  translation,
  height
}: BowtieListingResultListItemProps) => {
  
  const {    
    permissions
  } = useSelectorsTile(resultItem.caseNumber, resultItem.entityId, resultItem.entityStoreKey);
  
  const openBowtie = (caseNumber: number) => () => navigate.toBowtie(caseNumber, true);

  if(!permissions) {
    //it takes some time to load permissions in case reports; avoid displaying not supported message before rendering each bowtie
    return null;
  }

  return (
    !!permissions?.bowtie ?
      <BowtieSearchResult caseNumber={resultItem.caseNumber}
        height={height}
        footer={
          <ButtonInline onClick={openBowtie(resultItem.caseNumber)} className={styles.linkButton}>
            {translation.text_open_bowtie}
          </ButtonInline>}
      />
      : <div>{translation.text_bowtie_not_supported + ' ' + resultItem.caseNumber}</div>);
};
